// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables for Instec */\n\n/* Mixins */\n.admin-textarea textarea {\n  padding-right: 40px;\n  resize: none;\n  border: none;\n  border-radius: 0px;\n  border-bottom: 1px solid #bfcbd9;\n}\n.admin-block.form-block {\n  width: 55%;\n}", ""]);
// Exports
exports.locals = {
	"menuBg": "#0F4C81",
	"menuText": "#ffffff",
	"menuActiveText": "#0F4C81",
	"menuActiveBg": "#ffffff"
};
module.exports = exports;
